import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export const AccuracyNote = ({ compact, className = "" }) => {
  const { t } = useTranslation();
  return (
  <div data-testid="accuracy-note"
    className={`rounded-md border border-cyan/30 bg-cyan/5 p-3 flex gap-2.5 ${className}`}>
    <Info size={compact ? 15 : 17} className="text-cyan shrink-0 mt-0.5" />
    <p className={`text-slate-300 leading-relaxed ${compact ? "text-[11px]" : "text-xs"}`}>{t("accuracy.text")}</p>
  </div>
  );
};

